module.exports = __webpack_public_path__ + "img/b_01.ae86b7e2.png";